import { apiClient, type components } from '@boothiva/api-client';

export type TenantUsageSummary = components['schemas']['TenantUsageSummaryResponse'];
export type Plan = components['schemas']['PlanResponse'];
export type Subscription = components['schemas']['SubscriptionResponse'];
export type CreateCheckoutSessionRequest = components['schemas']['CreateCheckoutSessionRequest'];

export const getTenantUsage = () => apiClient.get<TenantUsageSummary>('/api/v1/tenant/usage');
export const listPlans = () => apiClient.get<Plan[]>('/api/v1/tenant/billing/plans');
export const getSubscription = () => apiClient.get<Subscription>('/api/v1/tenant/billing/subscription');
export const createCheckoutSession = (request: CreateCheckoutSessionRequest) =>
  apiClient.post<{ url: string }>('/api/v1/tenant/billing/checkout-session', request);
export const createBillingPortalSession = () =>
  apiClient.post<{ url: string }>('/api/v1/tenant/billing/portal-session');
